import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp, waLink } from '../lib/whatsapp';

const { FiArrowUpRight, FiMapPin, FiPhone, FiClock, FiMail } = FiIcons;

const faqs = [
  {
    q: 'How do we begin?',
    a: 'Every project starts with a no-obligation conversation. We talk through your space, your timeline, and how you hope to live in it.',
  },
  {
    q: 'Do you take on projects outside New York?',
    a: 'Yes. While we are based in Brooklyn, we travel for the right project and have completed homes across the country.',
  },
  {
    q: 'What is your typical timeline?',
    a: 'A full-service interior runs anywhere from six to eighteen months depending on scope. Room refreshes and styling can be much shorter.',
  },
  {
    q: 'Do you work with existing furniture?',
    a: 'Always. Pieces you already love are part of your story, and we design around them rather than starting from a blank page.',
  },
];

function ContactSection() {
  return (
    <section className="contact-section section-wrap" id="contact">
      <div className="contact-grid">
        <div className="contact-info">
          <p className="eyebrow">Get in touch</p>
          <h2> Start a <br /> <em>conversation.</em> </h2>
          <p className="contact-lead"> Tell us a little about your space, your timeline, and how you hope to live in it. We reply to every message personally. </p>
          <div className="contact-details">
            <div className="contact-row">
              <SafeIcon icon={FiPhone} />
              <div>
                <span>Phone / WhatsApp</span>
                <a href={waLink("Hello Forma Interiors, I'd like to discuss a project.")} target="_blank" rel="noopener noreferrer"> +91 98765 43210 </a>
              </div>
            </div>
            <div className="contact-row">
              <SafeIcon icon={FiMail} />
              <div>
                <span>Email</span>
                <strong>studio@formainteriors.com</strong>
              </div>
            </div>
            <div className="contact-row">
              <SafeIcon icon={FiMapPin} />
              <div>
                <span>Studio</span>
                <strong>Brooklyn, New York</strong>
              </div>
            </div>
            <div className="contact-row">
              <SafeIcon icon={FiClock} />
              <div>
                <span>Hours</span>
                <strong>Mon – Fri · 9am – 6pm EST</strong>
              </div>
            </div>
          </div>

          <div className="contact-faqs">
            <h3 className="contact-faqs-title">A few things people ask</h3>
            {faqs.map((f, i) => (
              <details className="contact-faq" key={i}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>
        </div>

        <div className="contact-action">
          <div className="contact-action-inner">
            <h3>Prefer to chat directly?</h3>
            <p>Reach us on WhatsApp and we'll get back to you within one business day.</p>
            <button className="whatsapp-cta" type="button" onClick={() => openWhatsApp()}>
              <SafeIcon icon={FiArrowUpRight} /> Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
